import { render, staticRenderFns } from "./ProzessCopyToClipboard.vue?vue&type=template&id=1089b1cc"
import script from "./ProzessCopyToClipboard.vue?vue&type=script&lang=js"
export * from "./ProzessCopyToClipboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports